import { Component, OnInit } from '@angular/core';
import { DashboardLandingPageHandler } from './dashboard-landing-page.handler.';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
  selector: 'sym-dashboard-landing-page',
  templateUrl: './dashboard-landing-page.component.html',
  styleUrls: ['./dashboard-landing-page.component.scss'],
})
export class DashboardLandingPageComponent extends DashboardLandingPageHandler implements OnInit {
  constructor(
    public service: DashboardService,
    public headerService: HeaderService,
    public router: Router,
    public route: ActivatedRoute,
    public settingService: SettingService
  ) {
    super(service, headerService, router, route, settingService);
  }
}
